var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-header navbar navbar-fixed-top" }, [
    _c("div", { staticClass: "page-header-inner" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("a", {
        staticClass: "menu-toggler responsive-toggler",
        attrs: {
          href: "javascript:void(0);",
          "data-toggle": "collapse",
          "data-target": ".navbar-collapse"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "page-top" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "top-menu" }, [
          _c("ul", { staticClass: "nav navbar-nav pull-right" }, [
            _c("li", { staticClass: "dropdown" }, [
              _c(
                "div",
                {
                  staticClass: "input-icon right",
                  staticStyle: {
                    "margin-top": "18px !important",
                    "margin-left": "15px"
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.global_user_search,
                        expression: "global_user_search"
                      }
                    ],
                    staticClass: "form-control input-large",
                    attrs: {
                      type: "text",
                      placeholder: "Quick Search (UID, CID, BUSINESS NAME)...",
                      name: "global_user_search",
                      id: "global_user_search",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.global_user_search },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.global_user_search = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.userDetails && _vm.is_display_userData
                    ? _c("div", { attrs: { id: "global_user_search_data" } }, [
                        _c(
                          "ul",
                          { staticClass: "user_sub-menu" },
                          _vm._l(_vm.userDetails.data, function(user_item) {
                            return _c("li", { key: user_item }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      _vm.host +
                                      "/admin/users/display/" +
                                      user_item.id
                                  }
                                },
                                [
                                  _c("h4", [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(user_item.first_name) +
                                          " " +
                                          _vm._s(user_item.last_name)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  user_item.user_business.company
                                    ? _c("p", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              user_item.user_business.company
                                                .company_name
                                            ) + " "
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(_vm._s(user_item.email) + " ")
                                  ])
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("li", { staticClass: "dropdown dropdown-user" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-toggle",
                  attrs: { href: "javascript:void(0);" }
                },
                [
                  _c(
                    "span",
                    { staticClass: "username username-hide-on-mobile" },
                    [
                      _vm._v(
                        "\n                              Welcome, " +
                          _vm._s(_vm.user.first_name) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.user.change_type == 1
              ? _c("li", { staticClass: "dropdown dropdown-user" }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-toggle",
                      attrs: { href: "#", "data-toggle": "dropdown" },
                      on: {
                        click: function($event) {
                          _vm.showDropDown = !_vm.showDropDown
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "username" }, [
                        _vm._v("Switch to ")
                      ]),
                      _c("span", { staticClass: "caret" })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showDropDown
                    ? _c("ul", { staticClass: "dropdown-menu" }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.switchToBusiness()
                                }
                              }
                            },
                            [_vm._v("Business Account")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.switchToWCU()
                                }
                              }
                            },
                            [_vm._v("Partner Account")]
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "dropdown-user" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-toggle",
                  on: {
                    click: function($event) {
                      return _vm.logout()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-sign-out" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "username username-hide-on-mobile" },
                    [_vm._v("\n                              Logout ")]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-logo" }, [
      _c("a", { attrs: { href: "/" } }, [
        _c("img", {
          staticClass: "logo-default",
          attrs: { src: "/static/admin/images/logo.png", alt: "alt" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu-toggler sidebar-toggler" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "form",
      {
        staticClass: "search-form search-form-expanded",
        attrs: { action: "#", method: "GET" }
      },
      [
        _c(
          "h2",
          {
            staticStyle: {
              "font-weight": "400",
              color: "#fff",
              "margin-left": "10px"
            }
          },
          [_vm._v("B1G1 Admin System")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      { staticClass: "dropdown", attrs: { id: "header_inbox_bar" } },
      [
        _c(
          "a",
          {
            staticStyle: { margin: "0px", padding: "28px 16px 19px 16px" },
            attrs: { href: "#" }
          },
          [
            _c("i", {
              staticClass: "icon-envelope-open",
              staticStyle: { "font-size": "18px", color: "#fff" }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "badge badge-default",
                staticStyle: {
                  display: "none",
                  "background-color": "#00b4eb",
                  color: "#ffffff",
                  position: "absolute",
                  top: "17px",
                  right: "9px",
                  "font-weight": "300",
                  padding: "3px 6px"
                },
                attrs: { id: "message_unread_total" }
              },
              [_vm._v("\n                              0 ")]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7d61206", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7d61206","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Header.vue
// module id = null
// module chunks = 